import moment from 'moment'

export default class Domain {

    zoneId
    recordId
    record
    domain
    token
    sysUserId
    clientId
    created
    modified
    active
    dnsLastUpdate

    static fromObject (o) {
        if (typeof o['zoneId'] !== 'number') {
            throw new Error('Missing field zoneId for Domain.')
        }
        if (typeof o['recordId'] !== 'number') {
            throw new Error('Missing field recordId for Domain.')
        }
        if (typeof o['record'] !== 'string') {
            throw new Error('Missing field record for Domain.')
        }
        if (typeof o['domain'] !== 'string') {
            throw new Error('Missing field domain for Domain.')
        }
        if (typeof o['token'] !== 'string') {
            throw new Error('Missing field token for Domain.')
        }
        if (typeof o['sysUserId'] !== 'number') {
            throw new Error('Missing field sysUserId for Domain.')
        }
        if (typeof o['clientId'] !== 'number') {
            throw new Error('Missing field clientId for Domain.')
        }
        if (typeof o['created'] !== 'string') {
            throw new Error('Missing field created for Domain.')
        }
        if (typeof o['modified'] === 'undefined' || (typeof o['modified'] !== 'string' && o['modified'] !== null)) {
            throw new Error('Missing field modified for Domain.')
        }
        if (typeof o['active'] !== 'boolean') {
            throw new Error('Missing field active for Domain.')
        }
        if (typeof o['dnsLastUpdate'] !== 'string') {
            throw new Error('Missing field dnsLastUpdate for Domain.')
        }

        try {
            const d = new Domain()
            d.zoneId = o['zoneId']
            d.recordId = o['recordId']
            d.record = o['record']
            d.domain = o['domain']
            d.token = o['token']
            d.sysUserId = o['sysUserId']
            d.clientId = o['clientId']
            d.created = moment(o['created']).utc()
            d.modified = o['modified'] === null ? null : moment(o['modified']).utc()
            d.active = o['active']
            d.dnsLastUpdate = moment(o['dnsLastUpdate']).utc()
            return d
        } catch (e) {
            throw new Error(`Failed to create Domain from object: ${e}`)
        }
    }

    getFqdn() {
        return this.record !== '' ? `${this.record}.${this.domain}` : this.domain
    }

}
